module.exports = __webpack_public_path__ + "img/queda de  folhas 2.1f0e1c17.webp";